import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
import router from './router'

// 创建应用实例
const app = createApp(App)

// 使用插件
app.use(router)
app.use(ElementPlus)

// 挂载应用
app.mount('#app')
